import React from 'react'
import Slider from 'react-slick'
import arrowLeft from '../images/arrow-circle-left.svg'
import arrowRight from '../images/arrow-circle-right.svg'

class InterchangeabilitySlider extends React.Component {

  optionalColors() {
    return this.props.optionalBits.map((bit, index) => (
      bit.colors[
        index === this.state.optionalBitIndex ?
          this.state.optionalColorIndex :
          0
      ]
    ))
  }

  renderSlide(image) {
    return (
      <div key={image.url}>
        <img src={this.props.isTall ? image.tall.src : image.normal.src} />
      </div>
    )
  }

  renderBaseSliderArrows() {
    return(
      <div style={{ textAlign: 'center' }}>
        <div className="slick-slider__arrow--basebits slick-slider--prev">
          <div
            className="slick-slider__arrow--prev"
            onClick={() => {
              this.baseSlider.slickPrev()
            }}
          > <img src={arrowLeft}/> </div>
          <p className="slick-slider__arrow__text">{this.props.prevBaseBit.name}</p>

        </div>
        <div className="slick-slider__arrow--basebits slick-slider--next">
          <p className="slick-slider__arrow__text">{this.props.nextBaseBit.name}</p>
          <div
            className="slick-slider__arrow--next"
            onClick={() => {
              this.baseSlider.slickNext()
            }}
          > <img src={arrowRight}/> </div>
        </div>
      </div>
    )
  }

  renderTopSliderArrows() {
    return(
      <div style={{ textAlign: 'center' }}>
        <div className="slick-slider__arrow--optionalbits slick-slider--prev">
          <div
            className="slick-slider__arrow--prev"
            onClick={() => {
              this.topSlider.slickPrev()
            }}
          > <img src={arrowLeft}/> </div>
          <p className="slick-slider__arrow__text">{this.props.prevTopBit.name}</p>
        </div>
        <div className="slick-slider__arrow--optionalbits slick-slider--next">
          <p className="slick-slider__arrow__text">{this.props.nextTopBit.name}</p>
          <div
            className="slick-slider__arrow--next"
            onClick={() => {
              this.topSlider.slickNext()
            }}
          > <img src={arrowRight}/> </div>
        </div>
      </div>
    )
  }

  renderBaseSlider(baseSettings) {
    return (
      <div className="base-bits-slider">
        <Slider
          {...baseSettings}
          ref={c => (this.baseSlider = c)}
        >
          {
            this.props.baseBitsImages.length > 0 &&
              this.props.baseBitsImages.map(i => this.renderSlide(i))
          }
        </Slider>
        {
          this.props.baseBitsImages.length > 1 &&
            this.renderBaseSliderArrows()
        }
      </div>
    )
  }

  renderTopSlider(topSettings) {
    return (
      <div className="optional-bits-slider">
        <Slider {...topSettings} ref={c => (this.topSlider = c)}>
          {this.props.optionalBitsImages.length > 0 &&
            this.props.optionalBitsImages.map(i => this.renderSlide(i))}
        </Slider>
        {
          this.props.optionalBitsImages.length > 1 &&
            this.renderTopSliderArrows()
        }
      </div>
    )
  }

  render() {
    const {optionalBitsImages, baseBitsImages} = this.props

    const responsive = [
      {
        breakpoint: 450,
        settings: {
          centerPadding: '50px',
        }
      }
    ];

    let min = 500;
    let max = 2200;

    for (let breakpoint = min; breakpoint < max; breakpoint += 50) {
      responsive.push({
        breakpoint,
        settings: {
          centerPadding: `${Math.floor(breakpoint * (0.15 + 0.15 * (breakpoint - min) / (max - min)))}px`,
        }
      })
    }

    const settings = {
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      arrows: false,
      responsive
    }

    const singleImageSettings = {
      infinite: false,
      slidesToShow: 1,
      centerMode: true,
      arrows: false,
      responsive
    }

    const baseSettings = Object.assign({}, settings, {
      afterChange: currentSlide => {
        this.props.changeSlide(currentSlide, true)
      },
    })
    const topSettings = Object.assign({}, settings, {
      afterChange: currentSlide => {
        this.props.changeSlide(currentSlide, false)
      },
    })

    return (
      <div className="slider-container">

        {
          baseBitsImages.length > 1 ?
          this.renderBaseSlider(baseSettings) :
            this.renderBaseSlider(singleImageSettings)
        }
        {
          optionalBitsImages.length > 0 &&
          optionalBitsImages.length > 1 ?
            this.renderTopSlider(topSettings) :
            this.renderTopSlider(singleImageSettings)
        }
      </div>
    )
  }
}

export default InterchangeabilitySlider



// WEBPACK FOOTER //
// ./src/components/InterchangeabilitySlider.js